import { useMemo } from 'react';

// context
import { AppContextProvider } from '@/components/utilities/AppContext';

// components
import Page404 from './Page404';
import Page500 from './Page500';
import PageHead from './PageHead';
import ComponentsRender from '@/components/ComponentsRender';
import ScrollSensor from '@/components/utilities/ScrollSensor';

// constants
import { LAYOUT_BLOCKS } from '@/components/components';

const Page = ({ pageData, error, locale, rootPath, restOfPath, queryParams, isPreview }) => {
  const appContext = useMemo(
    () => ({
      locale,
      rootPath,
      restOfPath,
      queryParams
    }),
    [locale, restOfPath, rootPath, queryParams]
  );

  if (error) {
    return <Page500 error={error} />;
  }

  if (!pageData) {
    return <Page404 />;
  }

  const { title, description, path, localizations } = pageData;

  return (
    <>
      <PageHead
        title={title}
        description={description}
        path={path}
        locale={locale}
        localizations={localizations}
        isPreview={isPreview}
      />

      <AppContextProvider value={appContext}>
        <ScrollSensor>
          {(pageData.content || []).map((component) => (
            <ComponentsRender
              key={`${component.id}_${component.__typename}`}
              type={LAYOUT_BLOCKS}
              component={component}
            />
          ))}
        </ScrollSensor>
      </AppContextProvider>
    </>
  );
};
export default Page;
